import t, { AsHtml } from "../../../../../utils/translate";

import styles from "./styles.module.scss";

export default function Message({ message, translate = true }) {
  return (
    <div className={styles.message}>
      <AsHtml
        className={styles.innerMessage}
        value={translate ? t(message) : message}
      />
    </div>
  );
}
